
<template>
  <FontAwesomeIcon
    v-if="showScrollToTop"
    :icon="faChevronUp"
    class="text-2xl bg-secondary rounded-full p-2 cursor-pointer fixed bottom-3 right-3 scroll-to-top-button"
    @click="scrollToTop"
  />
</template>

<script setup>
import { onMounted, onUnmounted, ref } from 'vue';
import { faChevronUp } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

const showScrollToTop = ref(false);

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
};

const checkScrollPosition = () => {
  const scrollThreshold = window.innerHeight;
  showScrollToTop.value = (window.scrollY > scrollThreshold) && window.innerWidth < 768;
};

onMounted(() => {
  window.addEventListener('scroll', checkScrollPosition);
  checkScrollPosition();
});

onUnmounted(() => {
  window.removeEventListener('scroll', checkScrollPosition);
});
</script>
